export default __webpack_public_path__ + "static/media/A4PosterLeftCropped2.b920fe97.png";